document.addEventListener("DOMContentLoaded", function () {
  if (!localStorage.getItem('cookiesAcknowledged')) {
    var banner = document.getElementById('cookie-banner');
    if (banner) banner.style.display = 'block';
  }

  var closeBtn = document.getElementById('cookie-close');
  if (closeBtn) {
    closeBtn.onclick = function () {
      localStorage.setItem('cookiesAcknowledged', 'true');
      document.getElementById('cookie-banner').style.display = 'none';
    };
  }
});
